import { combineReducers, createReducer } from '@reduxjs/toolkit';
import { GlobalRouter } from '@okapi/router-react';
import { createReducer as createRouterReducer } from '@okapi/router-connect';
import { createReducer as createCookieReducer } from 'isomorphic-redux-cookie-middleware';

import pageModelReducer from 'domains/pageModel/store/reducer';
import getCustomerIdReducer from 'domains/configurator/store/reducer';

export type TStateEnv = {
  ORCHESTRATOR_HOST: string;
  SELF_ORCHESTRATOR_HOST: string;
  CONFIGURATOR_URL: string;
  USE_CREDENTIALS: boolean;
  requestID: string;
  apiKey?: string;
  HIDE_HEADER_AND_FOOTER?: boolean;
};

type TRootReducerProps = {
  router: GlobalRouter;
  host: string;
  cookie: string;
  userAgent: string;
  env: TStateEnv;
};

export const rootReducer = ({ router, host, cookie, userAgent, env }: TRootReducerProps) =>
  combineReducers({
    domains: combineReducers({
      pageModel: pageModelReducer,
      configurator: getCustomerIdReducer,
    }),
    router: createRouterReducer(router),
    host: createReducer(host, () => {}),
    cookies: createCookieReducer(cookie),
    userAgent: createReducer(userAgent, () => {}),
    env: createReducer(env, () => {}),
  });

export type RootState = ReturnType<ReturnType<typeof rootReducer>>;
